import { API_URL } from '../../lib/api-client';

export interface CopilotHistoryMessage {
  id: string;
  role: 'user' | 'assistant';
  type: string;
  content: string;
  payload: Record<string, unknown>;
  created_at: number;
}

export async function loadCopilotHistory(token: string) {
  const response = await fetch(`${API_URL}/v1/crm/copilot/history?limit=50`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'copilot_history_failed');
  return (data.items || []) as CopilotHistoryMessage[];
}
